export function isIpAddress(hostname: string): boolean {
  return /^(\d{1,3}(\.\d{1,3}){3}|\[[0-9a-f:]+\])$/i.test(hostname);
}

// TLD-ish labels that are never the service's name, so "api.sentry.io" and
// "foo.example.co.uk" both yield the label users know the product by.
const GENERIC_DOMAIN_LABELS = new Set(["co", "com", "net", "org", "ac", "gov"]);

// Under a two-label public suffix the last two labels are the registry rather
// than the registrant, so api.tfl.gov.uk has to keep three or every UK
// government host looks like the same product.
function registrableLabelCount(labels: string[]): number {
  if (labels.length < 3) return 2;
  return GENERIC_DOMAIN_LABELS.has(labels[labels.length - 2]!) ? 3 : 2;
}

export function rootDomain(hostname: string): string {
  if (isIpAddress(hostname)) return hostname;
  const parts = hostname.split(".");
  const labels = registrableLabelCount(parts);
  return parts.length > labels ? parts.slice(-labels).join(".") : hostname;
}

export function domainFromUrlPattern(urlPattern: string): string | null {
  // Strip common regex anchors and unescape dots: ^https://api\.tines\.com → https://api.tines.com
  const cleaned = urlPattern.replace(/^\^/, "").replaceAll("\\.", ".");
  try {
    return rootDomain(new URL(cleaned).hostname);
  } catch {
    return null;
  }
}

export function domainSearchToken(targetUrl: string): string | undefined {
  let host: string;
  try {
    host = new URL(targetUrl).hostname;
  } catch {
    return undefined;
  }
  if (isIpAddress(host)) return undefined;
  const labels = host.split(".").filter(Boolean);
  if (labels.length < 2) return undefined;
  const token = labels[labels.length - registrableLabelCount(labels)]!;
  return token.length >= 3 ? token : undefined;
}
